import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />
        <TopicsSection />
        <CardsSection />
        <CommentsSection />
        <RankingSection />
        <CarouselSection />
        <ContactSection />
        <IndexSection />
        <FaqSection />
        <AboutSection />
        <AppSection />
        <FeaturesSection />
        <MediaSection />
        <UpdatesSection />
      </main>

      <Footer />
    </div>
  );
}